import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spin, Empty, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { blogAPI } from "../services/api";
import { titleToSlug } from "../utils/blogUtils";
import Header from "./header";
import Footer from "./footer";
import ContactForm from "./ContactForm";
import "../styles/blogs.css";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const response = await blogAPI.getAll({ status: 'published' });
      setBlogs(response.data.data || []);
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch (error) {
      return "";
    }
  };

  const getImageUrl = (blog) => {
    if (blog.featured_image) {
      if (blog.featured_image.startsWith('/uploads')) {
        const backendUrl = process.env.REACT_APP_ADMIN_API_URL || 'https://ampsweb.saassrs.com';
        return `${backendUrl}${blog.featured_image}`;
      }
      return blog.featured_image;
    }
    return "/images/backimg1.jpg"; 
  };

  return (
    <main>
      <Header />
      <section className="blogs-page">
        <div className="blogs-container">
          <div className="blogs-header">
            <h1 className="blogs-title">Blogs</h1>
            <p className="blogs-subtitle">Discover insights, stories, and updates from our team</p>
            {/* <Link to="/blogs/create">
              <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                size="large"
                style={{ marginTop: '1.5rem' }}
              >
                Create New Blog
              </Button>
            </Link> */}
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <Spin size="large" />
            </div>
          ) : blogs.length === 0 ? (
            <Empty 
              description="No blogs published yet" 
              style={{ padding: '60px 20px' }}
            />
          ) : (
            <div className="blogs-grid">
              {blogs.map((blog) => {
                const slug = blog.slug || titleToSlug(blog.title);
                return (
                <article key={blog.id} className="blog-card">
                  <Link to={`/blogs/${slug}`} className="blog-card__link">
                    <div className="blog-card__image">
                      <img 
                        src={getImageUrl(blog)} 
                        alt={blog.title}
                        onError={(e) => {
                          e.target.src = "/images/backimg1.jpg";
                        }}
                      />
                    </div>
                    <div className="blog-card__content">
                      <div className="blog-card__meta">
                        {blog.author_name && (
                          <span className="blog-card__author">{blog.author_name}</span>
                        )}
                        {blog.created_at && (
                          <span className="blog-card__date">{formatDate(blog.created_at)}</span>
                        )}
                      </div>
                      <h2 className="blog-card__title">{blog.title}</h2>
                      {blog.excerpt && (
                        <p className="blog-card__excerpt">{blog.excerpt}</p>
                      )}
                      <div className="blog-card__footer">
                        <span className="blog-card__read-more">Read More →</span>
                      </div>
                    </div>
                  </Link>
                </article>
                );
              })}
            </div>
          )}
        </div>
      </section>
      <ContactForm />

      <Footer />
    </main>
  );
}

